<template>
    <div class="m-update">
        <h5 class="title"></h5>
        <div class="slogen"></div>
        <div class="page-detail">
            <div class="update-view">
                <div class="m-tab">
                    <div class="tab-hd">
                        <div class="u-btn btn-tab t-1" @click="active_index = 1" :class="{'active' : active_index==1}"></div>
                        <div class="u-btn btn-tab t-2" @click="active_index = 2" :class="{'active' : active_index==2}"></div>
                    </div>

                    <div class="tab-view">
                        <div class="tab-item" :class="'t-' + active_index"><a :href="link[active_index - 1]" target="_blank" rel="noopener noreferrer"></a></div>
                    </div>

                    <p class="notice" v-if="active_index == 1">加入梦玩团大神扶持计划，送京东卡、绑定梦三币，期待与优秀的主播KOL共同成长。</p>
                    <p class="notice" v-if="active_index == 2">【单刀赴会】新服9月22日正式开服，历史充值返利、新兵福利多重惊喜等你来领！</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@mixin boxStyle ( $screenWidth ){

    .title{
        margin: 0 auto;

        @if ( $screenWidth == 1600) {
            width: 979px;
            height: 148px;
            background-image: url(~@/assets/images/pc/title-5.png);
        }@else if( $screenWidth == 1000 ) {
            width: 750px;
            height: 148px;
            background-image: url(~@/assets/images/m/title-5.png);
        }         
    }
    
    .m-tab{
        @if ( $screenWidth == 1600) {
            width: 959px;

            .notice{
                text-align: center;
            }
            .tab-hd{
                display: flex;
                justify-content: space-between;

                .btn-tab{
                    width: 469px;
                    height: 63px;
                    background-position: center;
                    background-repeat: no-repeat;

                    &.t-1{
                        background-image: url(~@/assets/images/pc/tab-u-1.png);

                        &:hover,&.active{
                            background-image: url(~@/assets/images/pc/tab-u-1_act.png);
                        }
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/pc/tab-u-2.png);

                        &:hover,&.active{
                            background-image: url(~@/assets/images/pc/tab-u-2_act.png);
                        }                    
                    }                
                }                
            }

            .tab-view{
                width: 959px;
                height: 472px;
                margin-top: 27px;
                margin-bottom: 30px;
                background-image: url(~@/assets/images/pc/img-view.png);

                .tab-item{
                    width: 100%;
                    height: 100%;

                    &.t-1{
                        background-image: url(~@/assets/images/pc/sample-2.png);
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/pc/sample-1.png);
                    }
                    
                    a{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }@else if( $screenWidth == 1000 ) {
            width: 710px;
            margin: 0 auto;

            .notice{
                height: 60px;
                text-align: center;
            }
            .tab-hd{
                display: flex;
                justify-content: space-between;

                .btn-tab{
                    width: 349px;
                    height: 63px;
                    background-position: center;
                    background-repeat: no-repeat;

                    &.t-1{
                        background-image: url(~@/assets/images/m/tab-u-1.png);

                        &.active{
                            background-image: url(~@/assets/images/m/tab-u-1_act.png);
                        }
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/m/tab-u-2.png);

                        &.active{
                            background-image: url(~@/assets/images/m/tab-u-2_act.png);
                        }                    
                    }                
                }                
            }

            .tab-view{
                width: 710px;
                height: 352px;
                margin-top: 27px;
                margin-bottom: 30px;
                background-image: url(~@/assets/images/m/img-view.png);

                .tab-item{
                    width: 100%;
                    height: 100%;

                    &.t-1{
                        background-image: url(~@/assets/images/m/tab-img-1.png);
                    }

                    &.t-2{
                        background-image: url(~@/assets/images/m/tab-img-2.png);
                    }
                    
                    a{
                        display: block;
                        width: 100%;
                        height: 100%;
                    }                    
                }

            }
        }           
    }

    @if ( $screenWidth == 1600) {

    }@else if( $screenWidth == 1000 ) {

    }    

}

@media screen and (min-width: 1000px){
@include boxStyle( 1600 );
}
@media screen and (min-width: 375px) and (max-width: 999px){
@include boxStyle( 1000 );
}
</style>

<script>
export default {
    data(){
        return {
            active_index : 1,
            link : ['https://mp.weixin.qq.com/s/HJk0X2NdrZaAYsVl1_gfDQ','https://www.m3guo.com/activity/202309/order-a76e/']
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/update.vue